import { render, staticRenderFns } from "./PasswordRequirments.vue?vue&type=template&id=87a43c90"
import script from "./PasswordRequirments.vue?vue&type=script&lang=js"
export * from "./PasswordRequirments.vue?vue&type=script&lang=js"
import style0 from "./PasswordRequirments.vue?vue&type=style&index=0&id=87a43c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports